import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class ServiceTypeToCopyFrom {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  @IsOptional()
  code!: string | null;
  @Expose()
  @IsString()
  vat!: string;
}

export class CopyServiceTypeSettings {
  @Expose()
  @IsNumber()
  @IsOptional()
  serviceTypeId!: number | null;
  @Expose()
  @IsBoolean()
  copyServiceAttributes!: boolean;
  @Expose()
  @IsBoolean()
  copyContractorAttributes!: boolean;
  @Expose()
  @IsBoolean()
  copyContractorTradeTerms!: boolean;
}
